import React from 'react';
import FormCard from './FormCard';

interface AISuggestOffFormProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  showAIButton?: boolean;
  onAIConsult?: () => void;
}

const AISuggestOffForm: React.FC<AISuggestOffFormProps> = ({
  label,
  value,
  onChange,
  placeholder,
  showAIButton = false,
  onAIConsult,
}) => {
  return (
    <FormCard>
      {/* Form Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center mb-3">
        {/* Heading */}
        <h3
          className="text-lg font-bold"
          style={{
            fontFamily: 'Noto Sans JP',
            color: '#0D357F',
          }}
        >
          {label}
        </h3>

        {/* AI Button */}
        {showAIButton && (
          <button
            type="button"
            className="px-4 py-2 rounded-lg text-sm font-medium text-white"
            style={{
              background: '#0D357F',
              opacity: onAIConsult ? 1 : 0.6,
              cursor: onAIConsult ? 'pointer' : 'default',
              fontFamily: 'Noto Sans JP',
            }}
            onClick={onAIConsult}
            disabled={!onAIConsult}
          >
            AI相談
          </button>
        )}
      </div>

      {/* Input Field */}
      <input
        type="text"
        value={value}
        onChange={(e) => {
          console.log('[AISuggestOffForm] onChange called:', { value: e.target.value });
          onChange(e.target.value);
        }}
        placeholder={placeholder}
        className="w-full px-3 py-3 border border-gray-300 rounded-lg text-sm"
        style={{
          fontFamily: 'Noto Sans JP',
        }}
      />
    </FormCard>
  );
};

export default AISuggestOffForm;
